import { Key, KeyboardColumn, SpecialKey } from './keyboard.types';

export const shortPhonemes: KeyboardColumn = {
  keys: [
    new SpecialKey('▯', 'shortPhonemes', {
      variant: undefined,
    }),
    ...['a', 'e', 'o', 'u', 'i'].map((key) => new Key(key)),
  ],
};

export const longPhonemes: KeyboardColumn = {
  keys: [
    new SpecialKey('▭', 'longPhonemes', {
      variant: undefined,
    }),
    ...['aa', 'ee', 'oo', 'uu'].map((key) => new Key(key)),
  ],
};

export const twoLetterPhonemes: KeyboardColumn = {
  keys: [
    new SpecialKey('||', 'twoLetterPhonemes', {
      variant: undefined,
    }),
    ...['ei', 'ij', 'ie', 'au', 'ou', 'oe', 'ui', 'uw', 'ch', 'ng', 'nk'].map((key) => new Key(key)),
  ],
};

export const threeLetterPhonemes: KeyboardColumn = {
  keys: [
    new SpecialKey('|||', 'threeLetterPhonemes', {
      variant: undefined,
    }),
    ...['aai', 'ooi', 'oei', 'auw', 'ouw'].map((key) => new Key(key)),
  ],
};

export const fourLetterPhonemes: KeyboardColumn = {
  keys: [
    new SpecialKey('||||', 'fourLetterPhonemes', {
      variant: undefined,
    }),
    ...['eeuw', 'ieuw'].map((key) => new Key(key)),
  ],
};

export const consonantPhonemes: KeyboardColumn = {
  keys: [
    new SpecialKey('■', 'consonantPhonemes', {
      variant: undefined,
    }),
    ...['b', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'r', 's', 't', 'v', 'w', 'z'].map((key) => new Key(key)),
  ],
};

export const rows = {
  shortPhonemes,
  longPhonemes,
  twoLetterPhonemes,
  threeLetterPhonemes,
  fourLetterPhonemes,
  consonantPhonemes,
};
